import { useCallback, useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { PageHeader, Panel, Empty } from "@/components/app/PageParts";
import { IpAssetDialog } from "@/components/app/IpAssetDialog";
import { api, errorMessage } from "@/lib/api";
import { IP_TYPES, formatDate } from "@/lib/format";

export const IpNotice = () => (
  <p data-testid="ip-notice" className="rounded-md border border-slate-200 bg-slate-50 p-3 text-xs text-slate-600">
    Optional tool for business brands and inventions. Your records are private to this workspace. <strong>USPTO monitoring: Not connected. Automatic alerts: Not connected yet.</strong> You or your authorized professional file and pay with the USPTO yourselves. EVR never files, signs, pays, or asks for USPTO login details.
  </p>
);

export default function IpAssets() {
  const { workspace } = useOutletContext();
  const [assets, setAssets] = useState(null);
  const [open, setOpen] = useState(false);
  const load = useCallback(() => { api.get(`/workspaces/${workspace.id}/ip-assets`).then(({ data }) => setAssets(data.assets)).catch((e) => toast.error(errorMessage(e))); }, [workspace.id]);
  useEffect(load, [load]);
  return (
    <div data-testid="ip-page">
      <PageHeader eyebrow="Optional" title="Trademarks & patents" subtitle="Keep registration and grant details in one place, and track the maintenance dates you've confirmed."
        action={<Button onClick={() => setOpen(true)} data-testid="ip-create-button" className="bg-navy hover:bg-navy-2"><Plus className="mr-1.5 h-4 w-4" /> Add record</Button>} />
      <div className="mb-6"><IpNotice /></div>
      <Panel title={`Records (${assets?.length ?? 0})`} testId="ip-list">
        {assets && !assets.length ? <Empty testId="ip-empty">No trademark or patent records yet.</Empty> : (
          <ul className="divide-y">{(assets || []).map((a) => (
            <li key={a.id} data-testid={`ip-row-${a.id}`} className="px-5 py-4">
              <Link to={`/app/w/${workspace.id}/ip/${a.id}`} className="text-sm font-medium text-navy hover:underline" data-testid="ip-open-link">{a.title}</Link>
              <p className="text-xs text-slate-500">{IP_TYPES[a.asset_type]}{a.number && ` · No. ${a.number}`}{a.key_date && ` · ${formatDate(a.key_date)}`} · {a.verification_status === "customer_checked_official_record" ? "Checked against official record" : "Not yet checked against official record"}</p>
            </li>))}</ul>
        )}
      </Panel>
      {open && <IpAssetDialog workspaceId={workspace.id} open onOpenChange={setOpen} onSaved={load} />}
    </div>
  );
}
